"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _PlannerMonth = _interopRequireDefault(require("@oberoninternal/travelbase-ds/components/calendar/PlannerMonth"));
var _addDays = _interopRequireDefault(require("date-fns/addDays"));
var _isSameMonth = _interopRequireDefault(require("date-fns/isSameMonth"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _usePlannerModifier = _interopRequireDefault(require("../hooks/planner/usePlannerModifier"));
const _excluded = ["trips", "period"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var __jsx = _react.default.createElement;
const MemoizedPlannerMonth = _ref => {
  let {
      trips,
      period
    } = _ref,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  const {
    date
  } = props;
  // We only care about trips that are in the month
  const relevantTrips = (0, _react.useMemo)(() => {
    const foundTrips = new Map();
    for (const trip of trips) {
      if ((0, _isSameMonth.default)(new Date(trip.date), date) || (0, _isSameMonth.default)((0, _addDays.default)(new Date(trip.date), trip.duration), date)) {
        const dayTrips = foundTrips.get(trip.date) ?? [];
        foundTrips.set(trip.date, [...dayTrips, trip]);
      }
    }
    return foundTrips;
  }, [date, trips]);
  const computeDayProps = (0, _usePlannerModifier.default)({
    period,
    selecting: props.isSelecting
  }, relevantTrips);
  return __jsx(StyledPlannerMonth, (0, _extends2.default)({}, props, {
    computeDayProps: computeDayProps
  }));
};
const isMonthRelevant = (period, date) => period?.start && ((0, _isSameMonth.default)(period.start, date) || period?.end && (0, _isSameMonth.default)(period.end, date));
var _default = exports.default = /*#__PURE__*/(0, _react.memo)(MemoizedPlannerMonth, (prev, next) => {
  if (+prev.date !== +next.date) {
    return false;
  }
  if (prev.loading && next.loading) {
    return true;
  }
  if (isMonthRelevant(next.period, next.date) || isMonthRelevant(prev.period, prev.date)) {
    return false;
  }

  // Shallow compare everything else
  // Note we're ignoring computeDayProps and clickHandlers as they could cause expensive rerenders
  // and they're callbacks anyway
  const ignore = ['date', 'onDayClick', 'computeDayProps', 'onDayMouseEnter', 'onDayMouseLeave', 'period', 'periodColor'];
  return Object.keys(next).filter(key => !ignore.includes(key)).every(key => Object.is(prev[key], next[key]));
});
const StyledPlannerMonth = (0, _styledComponents.default)(_PlannerMonth.default).withConfig({
  displayName: "MemoizedPlannerMonth__StyledPlannerMonth",
  componentId: "sc-1yus5ca-0"
})(["@media screen and (min-width:", "){width:calc(50% - (var(--monthGap) * 1px) / 2);}@media screen and (min-width:", "){width:calc(100% / 3 - (var(--monthGap) * 1px * 2) / 3);}"], ({
  theme
}) => theme.mediaQueries.s, ({
  theme
}) => theme.mediaQueries.xl);